import { render, staticRenderFns } from "./grammar-directory.vue?vue&type=template&id=0d6900f7&scoped=true&"
import script from "./grammar-directory.vue?vue&type=script&lang=js&"
export * from "./grammar-directory.vue?vue&type=script&lang=js&"
import style0 from "./grammar-directory.vue?vue&type=style&index=0&id=0d6900f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6900f7",
  null
  
)

export default component.exports